import { Component, forwardRef } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { TranslateService } from '@ngx-translate/core';
import { FeatureSystemFilter } from '../../../../Model/Dto/FeatureSystemFilter';
import { ExportFilterService } from '../../../../Services/exportFilter.service';
import { CategoryFilterTreeItem } from '../../../../Model/Catalog/exportFilter/categoryFilterTreeItem';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';

@Component({
  selector: 'userAction-removeUdxOnProducts',
  templateUrl: 'userAction-removeUdxOnProducts.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionRemoveUdxOnProducts) }
  ]})
export class UserActionRemoveUdxOnProducts extends UserActionBaseComponent {
  udxFilters: CategoryFilterTreeItem[];
  checkedUdx: CategoryFilterTreeItem[];
  isUdxLoaded: boolean;

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService,
    public exportFilterService: ExportFilterService,
    public systemService: SystemService
  ) {
    super(loginService, macroService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.udxFilters = new Array<CategoryFilterTreeItem>();
    this.isUdxLoaded = false;
    this.refreshUdxFilter();
  }

  refreshUdxFilter() {
    this.exportFilterService
      .getUdxFilterTreeElements(
        this.catalogService.selectedCatalogId,
        this.loginService.currentUser.customerId
      )
      .subscribe((filter: CategoryFilterTreeItem[]) => {
        this.udxFilters = filter;
        this.isUdxLoaded = true;
      });
  }

  public async canStartMacro() : Promise<boolean>{
    if (this.checkedUdx == undefined || this.checkedUdx.length == 0) {
      this.systemService.notifyInfo('Mindestens ein UDX auswählen');
      return false;
    }

    return true;
  }

  parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.checkedUdx = parsed.Values;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }

  createParameterStringAsJsonString(): string {
    return  JSON.stringify({ Values: this.checkedUdx });
  }
}
